// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#modal-dados-socio .modal-card {\n  width: 700px;\n  max-width: 98%;\n}\n#modal-dados-socio .modal-card .modal-card-body {\n  padding: 1rem 2.25rem;\n  overflow: auto;\n}\n#modal-reenvio-formulario-com-ajustes .modal-card {\n  width: 700px;\n  max-width: 98%;\n}\n#modal-reenvio-formulario-com-ajustes .modal-card .modal-card-body {\n  padding: 1rem 2.25rem;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
